import React, { useState } from "react";
import { Grid } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";

import DatapointInput from "components/pages/transmissions/modal/patient/tabs/datapoints/input/DatapointInput";
import { Form, Formik } from "formik";
import SubmitButton from "components/Button/SubmitButton";

import useDataPoints from "components/pages/transmissions/modal/patient/tabs/datapoints/useDatapoints";
import { generateDataPointValidationSchema } from "components/pages/transmissions/modal/patient/tabs/datapoints/validation_schema/datapointValidationSchema";
import { getFormattedDate } from "utils/date";
import { DATE_FORMAT } from "static/date";

const Datapoints = () => {
  const [formChanged, setFormChanged] = useState({});

  const {
    isSchemaLoading,
    isDataPointLoading,
    isDataPointFetching,
    dataPointSchemaList,
    datapoint,
    handleReset,
    updateDataPoint,
  } = useDataPoints(formChanged, setFormChanged);

  if (isSchemaLoading || isDataPointLoading || isDataPointFetching) {
    return (
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        style={{ height: "500px" }}
      >
        <LoadingSpinner />
      </Grid>
    );
  }

  return (
    <main className="patient-modal__aside-container">
      <div className="patient-form__info--header mt-0">Data points</div>
      <Formik
        initialValues={datapoint || {}}
        validationSchema={generateDataPointValidationSchema(
          dataPointSchemaList || []
        )}
        onSubmit={() => updateDataPoint()}
        enableReinitialize
      >
        {({
          values,
          isSubmitting,
          handleSubmit,
          setFieldValue,
          errors,
          isValid,
        }) => (
          <Form>
            <Grid container spacing={2} alignItems="flex-start">
              {dataPointSchemaList &&
                dataPointSchemaList?.map(
                  ({ key, inputType, title, placeholder }) => (
                    <Grid key={key} item xs={12} sm={6} md={3}>
                      <DatapointInput
                        name={key}
                        type={inputType}
                        label={title}
                        fullWidth
                        variant="outlined"
                        error={Boolean(errors[key])}
                        helperText={errors[key]}
                        value={values[key] ?? null}
                        placeholder={placeholder}
                        checked={values[key]}
                        onKeyPress={(event) => {
                          if (event?.key === "-" || event?.key === "+") {
                            event.preventDefault();
                          }
                        }}
                        formChanged={formChanged}
                        onChange={(e) => {
                          let value;
                          if (inputType === "date") {
                            value = getFormattedDate(e, DATE_FORMAT.DEFAULT);
                          } else if (inputType === "checkbox") {
                            value = e.target.checked;
                          } else {
                            value = e.target.value;
                          }

                          setFieldValue(key, value);
                          setFormChanged({
                            ...formChanged,
                            [key]:
                              inputType === "number" && value === ""
                                ? null
                                : value,
                          });
                        }}
                        handleReset={(fieldName) =>
                          handleReset(fieldName, setFieldValue, key)
                        }
                      />
                    </Grid>
                  )
                )}
            </Grid>
            <Grid item className="d-flex flex-end">
              <SubmitButton
                handleClick={handleSubmit}
                disabled={
                  isSubmitting || !isValid || !Object.keys(formChanged).length
                }
                buttonText={isSubmitting ? "Saving..." : "Save"}
              />
            </Grid>
          </Form>
        )}
      </Formik>
    </main>
  );
};
export default Datapoints;
